import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const PHONE_NUMBER = "+15054727064";
const PHONE_DISPLAY = "(505) 472-7064";

export const CTA = ({ 
  title = "Ready to Transform Your Bathroom?",
  subtitle = "Schedule your free consultation today and take the first step towards your dream bathroom."
}) => {
  const scrollToForm = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-[#1E4C9A] relative overflow-hidden" data-testid="cta-section">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 font-['Playfair_Display'] animate-fade-in" data-testid="cta-title">
          {title}
        </h2>
        <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto animate-fade-in delay-100">
          {subtitle}
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in delay-200">
          <Button
            onClick={scrollToForm}
            className="h-14 px-8 bg-white text-[#1E4C9A] hover:bg-gray-100 font-semibold text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
            data-testid="cta-quote-button"
          >
            Get Your Free Quote
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
          <a
            href={`tel:${PHONE_NUMBER}`}
            className="flex items-center gap-2 h-14 px-8 bg-transparent border-2 border-white text-white hover:bg-white/10 font-semibold text-lg rounded-full transition-all duration-300"
            data-testid="cta-phone-button"
          >
            <Phone className="h-5 w-5" />
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </section>
  );
};
